// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activity-card {
    width: 500px;
    height: fit-content;
    border-radius: 4px;
    background-color: #E8EBE4;
    color: #10310F;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.activity-card .activity-card-header {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    padding: 32px;
    gap: 16px;
}

.activity-card .activity-block {
    background-color: #E8EBE4;
}

.activity-card .activity-section {
    gap: 0px;
}

.activity-section .activity-block {
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;
    padding: 24px 32px;
    border-radius: 4px;
}

/* universal for normal/today activity card */

.activity-card-date {
    width: 120px;
    min-width: 120px;
}

.activity-card-event {
    display:flex;
    align-items: flex-center;
    gap: 32px;
}

.day {
    margin-bottom: 16px;
}

.day, .month {
    font-size: 20px;
}

.date {
    font-size: 48px;
    font-weight: bold;
}

.event-icon {
    width: 16px;
    height: auto;
}

.event {
    font-size: 16px;
}

.divider {
    border: 0;
    height: 1px;
    margin: 0 32px;
    background-color: #10310F;
}

.activity-section {
    display: flex;
    flex-direction: column;
}

.activity-time {
    width: 80px;
    min-width: 80px;
    font-size: 16px;
    font-weight: bold;
}

.activity {
    font-size: 16px;
    color: #10310F;
}`, "",{"version":3,"sources":["webpack://./src/css/ActivityCard.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,6CAA6C;;AAE7C;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB","sourcesContent":[".activity-card {\n    width: 500px;\n    height: fit-content;\n    border-radius: 4px;\n    background-color: #E8EBE4;\n    color: #10310F;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.activity-card .activity-card-header {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    padding: 32px;\n    gap: 16px;\n}\n\n.activity-card .activity-block {\n    background-color: #E8EBE4;\n}\n\n.activity-card .activity-section {\n    gap: 0px;\n}\n\n.activity-section .activity-block {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 16px;\n    padding: 24px 32px;\n    border-radius: 4px;\n}\n\n/* universal for normal/today activity card */\n\n.activity-card-date {\n    width: 120px;\n    min-width: 120px;\n}\n\n.activity-card-event {\n    display:flex;\n    align-items: flex-center;\n    gap: 32px;\n}\n\n.day {\n    margin-bottom: 16px;\n}\n\n.day, .month {\n    font-size: 20px;\n}\n\n.date {\n    font-size: 48px;\n    font-weight: bold;\n}\n\n.event-icon {\n    width: 16px;\n    height: auto;\n}\n\n.event {\n    font-size: 16px;\n}\n\n.divider {\n    border: 0;\n    height: 1px;\n    margin: 0 32px;\n    background-color: #10310F;\n}\n\n.activity-section {\n    display: flex;\n    flex-direction: column;\n}\n\n.activity-time {\n    width: 80px;\n    min-width: 80px;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.activity {\n    font-size: 16px;\n    color: #10310F;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
